module.exports = new __parcel__URL__("stamp01.96c012a7.png").toString();